module.exports = __webpack_public_path__ + "static/media/ring4.c1f743d8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/branding/default/audio/ring4.mp3
// module id = 614
// module chunks = 0